import { toast } from 'react-toastify';

interface ErrorInfo {
	[key: string]: any;
}

interface MessageJson {
	message: string;
	errors?: Array<{ errorMsg?: string; errorCode?: string }>;
	status?: number;
	error?: string;
	path?: string;
}

export default class ExceptionManager {
	static errorHandler(error: any = {}, errorInfo: ErrorInfo | null = null): any {
		const toastContainer = document.querySelector('.Toastify__toast-container');
		if (toastContainer && toastContainer?.children?.length > 0) {
			toast.dismiss();
		}

		if (errorInfo) {
			console.error(errorInfo);
		}

		let finalErrorMessage = '';
		const messageJson = error?.response?.data as MessageJson | null;

		if (messageJson) {
			finalErrorMessage = messageJson?.message;

			if (messageJson?.errors?.length) {
				if (messageJson?.errors[0]?.errorMsg) {
					finalErrorMessage = messageJson?.errors[0]?.errorMsg;
				}
			}
		}

		if ((finalErrorMessage || error || errorInfo) === 'Unauthorized') {
			localStorage.clear();

			toast.info(
				<div className="toast-error">
					<p>
						<b>Oturum Süreniz Dolmuştur</b>
					</p>
					<p>Tekrar Giriş Yapmanız Gerekiyor.</p>
				</div>
			);
			return error as Error;
		}

		if (messageJson) {
			if (process.env.MODE === 'prod' && messageJson.status && messageJson.status > 400 && messageJson.status !== 401) {
				toast.error(
					<div className="toast-error">
						<p>
							<b>Hata</b>
						</p>
						<p>Şu anda işleminizi gerçekleştiremiyoruz.</p>
					</div>
				);

				return error as Error;
			}

			toast.error(
				<div className="toast-error">
					<p>{finalErrorMessage}</p>
				</div>
			);
		} else if (typeof error.message === 'string' && error.message.match('the network is offline')) {
			toast.warning(
				<div className="toast-error">
					<p>
						<b>Hata</b>
					</p>
					<p>İnternet bağlantın ile ilgili sorun var. Lütfen internet bağlantını kontrol et.</p>
				</div>
			);

			return error as Error;
		} else {
			toast.error(
				<div className="toast-error">
					<p>
						<b>Error</b>
					</p>
					<p>{error.message}</p>
				</div>
			);
		}

		return error as Error;
	}

	static log(error: object = {}, errorInfo: ErrorInfo | null = null): void {
		console.log(error);

		if (errorInfo) {
			console.log(errorInfo);
		}
	}
}
